export { default } from './Error404'



// WEBPACK FOOTER //
// ./src/views/Error404/index.tsx